// extracted by mini-css-extract-plugin
export default {"table_container":"jobRolesTable_table_container__bU5w3","table-row":"jobRolesTable_table-row__wCsqz","AddroleButton":"jobRolesTable_AddroleButton__o79yq"};